import { DataBean } from "../DataBean";

export class MaterialAdjustment extends DataBean {



    public async createRawMaterialAdjustmentForProductionOrder(idStoreDestinity:any,idProductionOrder:any,productionOrderDate:any,accountantDate:any,description:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createRawMaterialAdjustmentForProductionOrder_Number_Number_java.util.Date_java.util.Date_String_Number", [idStoreDestinity,idProductionOrder,productionOrderDate,accountantDate,description,idEmployee]);
    }

    
}